import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Layer, VectorLayerDMTR } from 'src/app/menu/view-menu/layer';
import { Style, Stroke, Text, Fill } from 'ol/style';
import { Subject } from 'rxjs';
import { TopLevelLayers } from 'src/app/menu/view-menu/top-level-layers';
import { AnnotationModel } from 'src/app/models/annotation';
import VectorSource from 'ol/source/Vector';
import { MapService } from 'src/app/services/map.service';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { AnnotationService } from 'src/app/services/annotation.service';
import GeoJSON from 'ol/format/GeoJSON';
import { PointsService } from 'src/app/services/points.service';
import { CoordenateService } from 'src/app/services/coordenate.service';
import { AnnotationType } from 'src/app/models/EnumTypes';
import { ModalControlService } from 'src/app/services/modal-control.service';

@Component({
  selector: 'app-annotation',
  templateUrl: './annotation.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class AnnotationComponent implements OnInit {

  @Input() edit : Boolean;
  @Input() model : AnnotationModel;
  @Input() source : VectorSource;
  @Input() oldName : string;
  constructor(
    private bsModalRef : BsModalRef,
    private globalService : GlobalSelectionControlService,
    private annotationService : AnnotationService,
    private pointsService : PointsService,
    private rcsControl : CoordenateService,
    private modalService : ModalControlService) {
  }

  ngOnInit(): void {
    if(this.model == null){
      this.model = new AnnotationModel();
      this.model.font = 'Arial';
    }
  }

  cancel(): void{
    this.bsModalRef.hide();
  }

  validate(): string[] {
    let errors : string[] = [];
    this.pointsService.annotations.forEach(el => {
      if(el.name == this.model.name && el.id != this.model.id){
        errors.push("This annotation name already exists!")
      }
    })
    return errors;
  }

  createAnnotation(): void{
    let errors : string[] = this.validate();
    if(errors.length > 0){
      this.modalService.showMesssageModal('Validation Error', errors.reduce((acc,val)=>acc.concat(val)));
      return;
    }
    if(!this.edit){
      this.source.forEachFeature(el => {
        el.setProperties({
          annotationType: this.model.annotationType,
          name: this.model.name
        });
      })
      this.model.source = new GeoJSON().writeFeatures(this.source.getFeatures(), {
        dataProjection: 'CRS:84',
        featureProjection: this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
      });
    }
    this.annotationService.saveAnnotation(AnnotationModel.mapToService(this.model)).subscribe((data) => {
          let model : AnnotationModel = AnnotationModel.map(data);
          this.pointsService.annotations.set(model.id, model);
          if(this.edit){
            var layer = this.globalService.annotationLayers.childLayers.find(el => el.name == this.oldName);
            let newStyle : Style;
            if(this.model.annotationType == AnnotationType.Text){
              var font = model.lineWidth + "px " + model.font;
              newStyle = new Style({
                text: new Text({
                  font: font,
                  fill: new Fill({ color: model.color }),
                  text: model.text
                })
              })
            }else{
              newStyle = new Style({
                stroke: new Stroke({ color: model.color, width: model.lineWidth }),
              });
            }
            layer.layers.forEach(el => el.olLayer.setStyle(newStyle));
            if(this.oldName != model.name){
              layer.name = model.name;
            }
          }else{
            this.pointsService.createAnnotationLayer(this.model, this.source);
          }
        }, 
        (error) => {
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error',
              'Default Project is not editable.'
            )
            return;
          }
          this.modalService.showMesssageModal("Error", "An error occured saving the annotation");
        });
    this.bsModalRef.hide();
  }
}
